import getAddonBlocks from './blocks.js';
import getAddonViews from './views.js';
import reducers from 'uniba-volto-jwtsession/reducers';
import { LoginJWTViewlet } from 'uniba-volto-jwtsession/components';
import storeExtender from 'uniba-volto-jwtsession/storeExtender.js';

export default function applyConfig(config) {
    // console.log("CONFIG PRIMA");
    // console.log(config);
    config.views = {
        ...config.views,
        ...getAddonViews(config)
    };

    const customBlocks = {
        ...getAddonBlocks(config),
    };

    config.blocks = {
        ...config.blocks,
        blocksConfig: { ...config.blocks.blocksConfig, ...customBlocks }
    };

    config.addonReducers = {
        ...config.addonReducers,
        ...reducers,
    };

    config.settings.appExtras = [
        ...config.settings.appExtras,
        {
            match: '',
            component: LoginJWTViewlet,
        },
        // {
        //     match: '',
        //     component: GoogleAnalyticsPing,
        //     props: {
        //         'google-tag': '123456'
        //     }
        // },
        // {
        //     match: {
        //         path: '/blogs',
        //         exact: true,
        //     },
        //     component: WordClouds
        // },
        // {
        //     path: '/blog/**/edit',
        //     component: ExtraToolbarButton,
        // },
        // {
        //     match: {
        //         match: '/frontpage',
        //         ignore: '/frontpage/images',
        //     },
        //     component: FrontPage
        // },
    ];

    // RIMOSSO: utilizzo il proxy di ngnix per fare regole di routing
    // config.settings.externalRoutes = [
    //     ...config.settings.externalRoutes,
    //     {
    //         match: {
    //             path: '/query',
    //             exact: false,
    //             strict: false,
    //         },
    //         url: (payload) => {
    //             return config.settings.devProxyToApiPath + payload.location.pathname;
    //         },
    //     },
    // ];
    // ROUTES
    // config.addonRoutes = [
    //     ...config.addonRoutes,
    //     {
    //         path: '/**/query',
    //         component: QueryView,
    //     },
    // ];
    // config.widgets.widget.telefoni_widget = TelefoniWidget;
    // config.widgets.widget.fax_widget = FaxWidget;
    // config.widgets.widget.select_struttura_widget = SelectStrutturaWidget;
    // config.widgets.widget.checkbox_responsabile_widget = CheckboxResponsabileWidget;
    // config.widgets.widget.select_genere_ruolo = SelectGenereWidget;

    //VALIDATORS
    // config.registerUtility({
    //     type: 'validator',
    //     name: 'phoneNumberValidation',
    //     dependencies: {
    //         widget: 'telefoni_widget',
    //     },
    //     method: phoneValidator,
    // });

    // config.registerUtility({
    //     type: 'validator',
    //     name: 'faxValidation',
    //     dependencies: {
    //         widget: 'fax_widget',
    //     },
    //     method: faxValidator,
    // });
    // console.log("CONFIG DOPO");
    // console.log(config);

    config.settings.storeExtenders = [
        ...(config.settings.storeExtenders || []),
        storeExtender,
    ]
    return config;
}